__turbopack_context__.v({
  "circle": "FeaturedText-module-scss-module__AN1dIW__circle",
  "eyebrow": "FeaturedText-module-scss-module__AN1dIW__eyebrow",
  "featured-text": "FeaturedText-module-scss-module__AN1dIW__featured-text",
  "featured-text--center": "FeaturedText-module-scss-module__AN1dIW__featured-text--center",
  "featured-text--left": "FeaturedText-module-scss-module__AN1dIW__featured-text--left",
  "featured-text--right": "FeaturedText-module-scss-module__AN1dIW__featured-text--right",
  "headline": "FeaturedText-module-scss-module__AN1dIW__headline",
  "star": "FeaturedText-module-scss-module__AN1dIW__star",
});
